"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastAddedEmail = exports.getIsRecipientsAdded = exports.getHasErrors = exports.getErrors = exports.getIsSucceeded = exports.getIsInProgress = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var getRecipientState = function getRecipientState(state) {
  return state.modules.giftingOnTheFly.recipient;
};

var getIsInProgress = (0, _ramda.pipe)(getRecipientState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsInProgress = getIsInProgress;
var getIsSucceeded = (0, _ramda.pipe)(getRecipientState, function (state) {
  return state.status === _utils.StateStatus.Fulfilled;
});
exports.getIsSucceeded = getIsSucceeded;
var getErrors = (0, _ramda.pipe)(getRecipientState, function (state) {
  return state.errors;
});
exports.getErrors = getErrors;
var getHasErrors = (0, _ramda.pipe)(getErrors, function (errors) {
  return Object.keys(errors).length > 0;
});
exports.getHasErrors = getHasErrors;
var getIsRecipientsAdded = (0, _ramda.pipe)(getRecipientState, function (state) {
  return state.addedRecipientsCount > 0;
});
exports.getIsRecipientsAdded = getIsRecipientsAdded;
var getLastAddedEmail = (0, _ramda.pipe)(getRecipientState, function (state) {
  return state.lastAddedEmail;
});
exports.getLastAddedEmail = getLastAddedEmail;